var angular = require('angular')
var queryString = require('query-string')
var downloadjs = require('downloadjs')

angular.module('AemWcmContent')
  .controller('aemWcmContentCtrl', ctrl)

ctrl.$inject = ['wgService', 'contentService', 'appLoader']

function ctrl (wgService, contentService, appLoader) {
  var vm = this
  var portal = 'internet'
  var objectName = queryString.parse(window.location.search).documentId
  var objectNameExtension = objectName && objectName.split('.').reverse()[0]

  vm.$onInit = function () {
    vm.fileContent = null
    vm.wcmHrefContext = wgService.getParams().wcmHrefContext
    vm.isErrorBackend = false
    if (objectNameExtension && objectNameExtension.toLowerCase() === 'xml') {
      contentService.getStaticHtml(portal, objectName).promise
        .then(function (res) {
          vm.fileContent = res.data
        })
        .catch(function () {
          vm.isErrorBackend = true
        })
        .finally(function () {
          appLoader.hide()
        })
    } else {
      contentService.getStaticBlob(portal, objectName).promise
        .then(function (res) {
          downloadjs(res.data, objectName, 'application/' + objectNameExtension)
        })
        .catch(function () {
          vm.isErrorBackend = true
        })
        .finally(function () {
          appLoader.hide()
        })
    }
  }
}
